import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import App from './App';
import './index.css';

// Set dayjs to English
dayjs.locale('en');

// Custom theme configuration (Apple financial report style)
const theme = {
  token: {
    colorPrimary: '#0066CC', // Science Blue
    colorBgContainer: '#FFFFFF', // White
    colorBgLayout: '#F5F5F7', // Athens Gray
    colorText: '#1D1D1F', // Shark
    colorTextSecondary: '#86909C',
    borderRadius: 8,
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Layout: {
      bodyBg: '#F5F5F7',
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: '#E6F4FF',
      itemSelectedColor: '#0066CC',
    },
    Card: {
      borderRadiusLG: 12,
      boxShadowTertiary: '0 2px 8px rgba(0, 0, 0, 0.06)',
    },
    Button: {
      borderRadius: 6,
      fontWeight: 500,
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider 
      locale={enUS} 
      theme={theme}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);